var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_WeakMap.js
 ** module id = 1188
 ** module chunks = 0
 **/